/**
 * Accessible list-row chrome using nedi-ui-web tokens.
 * Keeps light-DOM title/subtitle for RTL + a11y (CE shadow titles are opaque in jsdom).
 */
export default function NediRowButton({
  title,
  subtitle,
  disabled = false,
  onClick,
  leading = null,
  className = '',
  'aria-label': ariaLabel,
}) {
  return (
    <button
      type="button"
      className={['nedi-row-btn', className].filter(Boolean).join(' ')}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel || title}
      data-nedi-anatomy="list-row"
    >
      {leading ? <span className="nedi-row-btn__leading" aria-hidden="true">{leading}</span> : null}
      <span className="nedi-row-btn__copy">
        <span className="nedi-row-btn__title">{title}</span>
        {subtitle ? <span className="nedi-row-btn__subtitle">{subtitle}</span> : null}
      </span>
      <span className="nedi-row-btn__disclosure" aria-hidden="true">›</span>
    </button>
  )
}
